interface Node {
    id : string;
    type : string;
    position: {
        x: number;
        y: number;
    }
    data: {
        label: string;
        info: any,
    }
    height: number,
    width: number,
}

interface Edge {
    id: string,
    source: string,
    target: string,
}

export const handleNodes = ( items: any, isPhase: boolean ) : Node[] => {

    let nodeArr: Node[] = [];
    let typeStr
    if(isPhase){
        typeStr= 'phaseNode'
    }
    else {
        typeStr = 'moduleNode'
    }

    for(let i=0; i < items.length; i++) {

        let newNode : Node = {
            id: i.toString(),
            type: typeStr,
            position: {
                x: i*75,
                y: i*100,
            },
            data: items[i],
            height: 60,
            width: 100,
        }

        nodeArr.push(newNode);
    }

    return nodeArr;

}

export const handleEdges = (items: any) => {

    let edgeArr: Edge[] = [];

    if(items.length === 1 || items.length === 0) {
        return edgeArr;    // no edges needed, empty array
    } 

    if(items.length === 2) {
        let newEdge:Edge;
        if(items[0].ordinal >= items[1].ordinal) {
            newEdge = {
                id: items[0].name + ' ' + items[1].name,
                source: '0',
                target: '1',
            }
        }
        else {
            newEdge = {
                id: items[1].name + ' ' + items[0].name,
                source: '1',
                target: '0',
            }
        }

        edgeArr.push(newEdge)
        return edgeArr
    }
    
    // for items of length more than 3, we need to check VC and links
    handleVC(items, edgeArr)
    
    return edgeArr;

}

const handleVC = (items: any, edgeArr: Edge[]) => {

    // we need to first establish the critical line
        // critical line is created between all nodes with EITHER no VC or same VC as first node

    let firstVC = JSON.stringify(items[0].visibilityCriteria)     // this is either populated or null
    let lastNode = items[0];
    let lastNum = 0;
    for(let k=1; k< items.length; k++) {
        if(items[k].visibilityCriteria === null || JSON.stringify(items[k].visibilityCriteria) === firstVC) {
            let edge: Edge = {
                id: lastNode.name + ' ' + items[k].name + ' VC',
                source: lastNum.toString(),
                target: k.toString(),
            }

            edgeArr.push(edge)
            lastNode = items[k]
            lastNum = k
        }
    }


    // Now we need to go through and look for any nodes with VC that do not match first node so we can connect them to main line
    for(let k=1; k<items.length;k++) {
        if(items[k].visibilityCriteria !== null && JSON.stringify(items[k].visibilityCriteria) !== firstVC) {
            // If the node before has the same VC, then we must connect them
            if(JSON.stringify(items[k-1].visibilityCriteria) === JSON.stringify(items[k].visibilityCriteria)) {
                let edge:Edge = {
                    id: items[k-1].name + ' ' + items[k].name + ' VC1',
                    source: (k-1).toString(),
                    target: k.toString()
                }   

                edgeArr.push(edge)
            }
            else { // we must look for most current node with no VC to connect the node to
                let mostRec = items[0];
                let src = 0;
                for(let j=1; j<k; j++) {
                    if(items[j].visibilityCriteria === null) {
                        mostRec = items[j];
                        src = j;
                    }
                }

                let edge1:Edge = {
                    id: mostRec.name + ' '+ items[k].name + 'VC2',
                    source: src.toString(),
                    target: k.toString(),
                }

                edgeArr.push(edge1)

                // now, we must find most recent node after our current one to connect to
                    // looking for a node with no VC or matching first node's VC
                    // if that does not exist, then this item is an ending node

                let notFound=true;
                let notEnd = true;
                let h=k+1;
                while(notFound && notEnd) {
                    if(items[h] === undefined || items[h] === null) {
                        notEnd = false; // break since we have found the end node
                        break
                    }
                    if(items[k].visibilityCriteria === null || JSON.stringify(items[k].visibilityCriteria) === firstVC) {
                        // this is on the critical path, so add an edge and break
                        let edge2: Edge = {
                            id: items[k].name + ' ' + items[h].name + ' VC3',
                            source: k.toString(),
                            target: h.toString(),
                        }

                        edgeArr.push(edge2)
                        notFound = false
                    }
                    else if (items[h].visibilityCriteria === null || JSON.stringify(items[h].visibilityCriteria) === firstVC) {
                        // this matches firstVC so it is in the critical path, so we need to add an edge and break

                        let edge2: Edge = {
                            id: items[k].name + ' ' + items[h].name + ' VC4',
                            source: k.toString(),
                            target: h.toString(),
                        }

                        edgeArr.push(edge2)
                        notFound = false;
                    }
                    h++;
                }
            }

        }
    }

}

export const getDate = (date: Date) => {
    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;   
}


